/**
 * MapLibre 6 finds its worker beside its own module, which isn't there once
 * Vite has bundled it (and not at all on the desktop app's avgv:// pages), so
 * Vite builds the worker as a file of its own and MapLibre is told where.
 *
 * @module
 */
import { setWorkerUrl } from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

setWorkerUrl(workerUrl);
